import { CHANGE_BOOKMAKER } from "./actionTypes";

const DEFAULT_BOOK_MAKER = "-1";

const BookmakerReducer = (state: string = DEFAULT_BOOK_MAKER, action: any) => {
  switch (action.type) {
    case CHANGE_BOOKMAKER:      
      return action.payload;
    default:
      return state;
  }
};

export default BookmakerReducer;
